import React from "react"
import { Card } from "react-bootstrap"
import { useSelector } from "react-redux"

import { getInventory } from "@/onboarding/features/inventory_allocation/selectors"
import { isBlank } from "@/utils"

import Header from "./Header"
import CapacityAllotments from "./CapacityAllotments"
import InventoryAllocationTableHeader from "./InventoryAllocationTableHeader"
import InventoryAllocationTable from "./InventoryAllocationTable"

const Dashboard = (): JSX.Element => {
  const inventory = useSelector(getInventory)

  if (isBlank(inventory.tour)) {
    return (
      <Card>
        <Header />
        <Card.Body>
          Select a port and tour above before you can begin allocating inventory.
        </Card.Body>
      </Card>
    )
  }

  return (
    <Card>
      <Header />
      <CapacityAllotments />
      <InventoryAllocationTableHeader />
      <InventoryAllocationTable />
    </Card>
  )
}

export default Dashboard
